import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { Link } from "react-router-dom";
import {
  deleteWorkingSchedule,
  updateWorkingSchedule,
  updateWorkingScheduleStatus,
  workingSchedulesList,
} from "../../api/Staff";
import {
  closeModal,
  formatDateTime,
  formatTime,
  ToastMain,
  SweetAlertShow,
  LoadingDiv,
} from "../master/Master";
import Swal from "sweetalert2";
import StaffLayout from "./StaffLayout";
import usePrivateLink from "../config/usePrivateLink";
export default function WorkingSchedule() {
  const hasAccess = usePrivateLink();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({});
  const [debouncedFilters, setDebouncedFilters] = useState(filters);
  const [modalData, setModalData] = useState(false);
  const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  const getWorkingSchedule = async () => {
    setLoading(true);
    try {
      let addUrl = "";
      Object.keys(debouncedFilters).forEach((key) => {
        const value = debouncedFilters[key];
        if (value) {
          addUrl += `&${key}=${encodeURIComponent(value)}`;
        }
      });
      const response = await workingSchedulesList(addUrl);
      if (response?.data?.status) {
        setData(response?.data?.data);
      } else {
        //  ToastMain.fire({
        //   icon:'info',
        //   title: response?.data?.message || 'something went wrong'
        //  })
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      // ToastMain.fire({
      //   icon:'error',
      //   title: err?.response?.data?.message || 'something went wrong'
      // })
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedFilters(filters);
    }, 500);

    return () => clearTimeout(timer);
  }, [filters]);

  useEffect(() => {
    getWorkingSchedule();
  }, [debouncedFilters]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await updateWorkingSchedule(formData);
      if (response.data.status) {
        //  ToastMain.fire({
        //   icon:'success',
        //   title: response?.data?.message || 'successfully'
        //  });

        SweetAlertShow("success", "successfully", response?.data?.message);
      } else {
        //   ToastMain.fire({
        //   icon:'info',
        //   title: response?.data?.message || 'something went wrong'
        //  });
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      //  ToastMain.fire({
      //   icon:'error',
      //   title: err?.response?.data?.message || 'something went wrong'
      //  });

      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      closeModal(`working_schedule_update`);
      setLoading(false);
      getWorkingSchedule();
    }
  };
  const handleStatus = async (id) => {
    setLoading(true);
    try {
      const response = await updateWorkingScheduleStatus(id);
      if (response.data.status) {
        // ToastMain.fire({
        //   icon:'success',
        //   title: response?.data?.message || 'Successfully'
        // })

        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        //  ToastMain.fire({
        //   icon:'info',
        //   title: response?.data?.message || 'something went wrong'
        //  })

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      // ToastMain.fire({
      //   icon:'error',
      //   title: err?.response?.data?.message || 'something went wrong'
      // })
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
      getWorkingSchedule();
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to undo this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    });

    if (result.isConfirmed) {
      setLoading(true);
      try {
        const response = await deleteWorkingSchedule(id);
        if (response.data.status == true) {
          // ToastMain.fire({
          //   icon:'success',
          //   title: response?.data?.message || 'success'
          // })

          SweetAlertShow("success", "Successfully", response?.data?.message);
        } else {
          // ToastMain.fire({
          //   icon:'info',
          //   title: response?.data?.message || 'something went wrong'
          // })

          SweetAlertShow("info", "Warning", response?.data?.message);
        }
      } catch (err) {
        // ToastMain.fire({
        //     icon:'info',
        //     title: err?.response?.data?.message || 'something went wrong'
        //   })

        SweetAlertShow(
          "error",
          "Error",
          err?.response?.data?.message ?? err?.message,
        );
      } finally {
        setLoading(false);
        getWorkingSchedule();
      }
    }
  };

  // useEffect(() => {
  //   getWorkingSchedule();
  // }, [filters]);

  // const hasAccess = usePrivateLink();

  const handlePrint = () => {
    const printContent = document.getElementById("printTable");

    if (!printContent) {
      return;
    }

    const printWindow = window.open("", "_blank", "width=1200,height=800");

    printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>Working Schedules</title>

      <style>
        @page {
          size: A4 landscape;
          margin: 10mm;
        }

        * {
          box-sizing: border-box;
        }

        body {
          font-family: Arial, sans-serif;
          margin: 0;
          padding: 20px;
          color: #000;
        }

        h2 {
          margin-bottom: 20px;
          text-align: center;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 12px;
        }

        th,
        td {
          border: 1px solid #ccc;
          padding: 8px;
          text-align: left;
          vertical-align: middle;
        }

        th {
          background: #f2f2f2;
          font-weight: bold;
        }

        img {
          max-width: 40px;
          max-height: 40px;
        }

        .badge {
          padding: 4px 8px;
          border: 1px solid #999;
          border-radius: 4px;
        }

        .btn,
        button,
        a {
          display: none !important;
        }

        @media print {
          body {
            padding: 0;
          }

          table {
            page-break-inside: auto;
          }

          tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }

          thead {
            display: table-header-group;
          }
        }
      </style>
    </head>

    <body>

      <h2>Staff List</h2>

      ${printContent.innerHTML}

    </body>
    </html>
  `);

    printWindow.document.close();

    printWindow.focus();

    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
  };
  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid mt-2">
                <div className="row">
                  <StaffLayout />

                  <div className="col-12">
                    <div className="card border-0 shadow-sm mb-4">
                      <div className="card-body">
                        <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center">
                          <div>
                            <h3 className="fw-bold text-primary mb-1">
                              <i className="ri-calendar-schedule-line me-2"></i>
                              Working Schedules
                            </h3>

                            <p className="text-muted mb-0">
                              Create and manage staff working schedules, timings
                              and weekly offs.
                            </p>
                          </div>
                          {hasAccess("/staff/schedule/create") && (
                            <>
                              <Link
                                to="/staff/schedule/create"
                                className="btn btn-primary mt-3 mt-lg-0"
                              >
                                <i className="ri-add-line me-1"></i>
                                Add Schedule
                              </Link>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row g-3 mb-4">
                      <div className="col-lg-3">
                        <div className="card border-0 shadow-sm">
                          <div className="card-body">
                            <small className="text-muted">
                              Total Schedules
                            </small>

                            <h3 className="fw-bold mt-2">{data.length}</h3>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="card border-0 shadow-sm">
                          <div className="card-body">
                            <small className="text-muted">Active</small>

                            <h3 className="fw-bold text-success mt-2">
                              {data.filter((x) => x.status === "1").length}
                            </h3>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="card border-0 shadow-sm">
                          <div className="card-body">
                            <small className="text-muted">Inactive</small>

                            <h3 className="fw-bold text-danger mt-2">
                              {data.filter((x) => x.status !== "1").length}
                            </h3>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="card border-0 shadow-sm">
                          <div className="card-body">
                            <small className="text-muted">
                              Avg Working Hours
                            </small>

                            <h3 className="fw-bold text-primary mt-2">
                              {data.length
                                ? (
                                  data.reduce(
                                    (a, b) =>
                                      a + Number(b.total_hours_per_day),
                                    0,
                                  ) / data.length
                                ).toFixed(1)
                                : 0}{" "}
                              Hrs
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card border-0 shadow-sm mb-4">
                      <div className="card-body">
                        <div className="row g-3 align-items-end">
                          <div className="col-lg-5">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search Schedule"
                                value={filters.search || ""}
                                onChange={(e) =>
                                  setFilters((prev) => ({
                                    ...prev,
                                    search: e.target.value,
                                  }))
                                }
                              />
                              <label>Search Schedule</label>
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select"
                                value={filters.status || ""}
                                onChange={(e) =>
                                  setFilters((prev) => ({
                                    ...prev,
                                    status: e.target.value,
                                  }))
                                }
                              >
                                <option value="">All Status</option>
                                <option value="1">Active</option>
                                <option value="2">Inactive</option>
                              </select>
                              <label>Status</label>
                            </div>
                          </div>

                          <div className="col-lg-4">
                            <div className="d-flex gap-2">
                              <button
                                type="button"
                                className="btn btn-outline-primary"
                                onClick={getWorkingSchedule}
                              >
                                <i className="ri-search-line me-1"></i>
                                Refresh
                              </button>
                              {hasAccess("/staff/print") && (
                                <button
                                  className="btn btn-outline-info me-2"
                                  title="Print Staff List"
                                  onClick={handlePrint}
                                >
                                  <i className="ri-printer-line me-1"></i>
                                  Print
                                </button>
                              )}

                              {(filters.search || filters.status) && (
                                <button
                                  type="button"
                                  className="btn btn-outline-danger"
                                  onClick={() => {
                                    setFilters({
                                      search: "",
                                      status: "",
                                    });
                                  }}
                                >
                                  <i className="ri-filter-off-line me-1"></i>
                                  Clear
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-body">
                        <div className="table-responsive" id="printTable">
                          <table className="table table-hover align-middle mb-0">
                            <thead className="table-light">
                              <tr>
                                <th style={{ width: "60px" }}>#</th>
                                <th style={{ minWidth: "280px" }}>Schedule</th>
                                <th style={{ width: "180px" }}>Timing</th>
                                <th style={{ minWidth: "240px" }}>
                                  Working Days
                                </th>
                                <th style={{ width: "150px" }}>
                                  Attendance Rules
                                </th>
                                <th style={{ width: "110px" }}>Status</th>
                                <th
                                  className="text-center"
                                  style={{ width: "110px" }}
                                >
                                  Actions
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {data?.map((item, index) => (
                                <tr key={item.id}>
                                  <td>{index + 1}</td>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <div className="text-start">
                                        <div className="fw-semibold">
                                          {item.name}
                                        </div>
                                        <div className="small text-muted">
                                          {Number(item.total_hours_per_day)}{" "}
                                          Hours / Day
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="text-center">
                                      <div className="fw-semibold">
                                        {formatTime(item.start_time)}
                                      </div>

                                      <div className="small text-muted">↓</div>

                                      <div className="fw-semibold">
                                        {formatTime(item.end_time)}
                                      </div>
                                    </div>
                                  </td>
                                  {/* <td>{Number(item.total_hours_per_day)}</td> */}
                                  <td>
                                    <div className="d-flex flex-wrap gap-1">
                                      {JSON.parse(
                                        item.working_days || "[]",
                                      ).map((day) => (
                                        <span
                                          key={day}
                                          className="badge rounded-pill bg-label-primary"
                                        >
                                          {day}
                                        </span>
                                      ))}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="small text-start">
                                      <div>
                                        <span className="badge rounded-pill bg-label-warning me-1">
                                          Late
                                        </span>
                                        {Number(item.late_mark)} Min
                                      </div>

                                      <div className="mt-1">
                                        <span className="badge rounded-pill bg-label-danger me-1">
                                          Early
                                        </span>
                                        {Number(item.early_mark)} Min
                                      </div>

                                      <div className="mt-1">
                                        <span className="badge rounded-pill bg-label-success me-1">
                                          OT
                                        </span>
                                        {Number(item.overtime_mark)} Min
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    {" "}
                                    <span
                                      onClick={() => handleStatus(item.id)}
                                      className={`badge rounded-pill px-3 py-2 cursor-pointer ${item.status === "1"
                                        ? "bg-label-success"
                                        : "bg-label-danger"
                                        }`}
                                      style={{
                                        cursor: "pointer",
                                      }}
                                    >
                                      <i
                                        className={`me-1 ${item.status === "1"
                                          ? "ri-checkbox-circle-fill"
                                          : "ri-close-circle-fill"
                                          }`}
                                      ></i>

                                      {item.status === "1"
                                        ? "Active"
                                        : "Inactive"}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <div className="d-flex justify-content-center gap-2">
                                      {hasAccess("/staff/schedule/edit") && (

                                      <button
                                        className="btn btn-sm btn-outline-primary"
                                        title="Edit"
                                        data-bs-toggle="modal"
                                        data-bs-target="#working_schedule_update"
                                        onClick={() => setModalData(item)}
                                      >
                                        <i className="ri-edit-line"></i>
                                      </button>
                                      )}
                                      {hasAccess("/staff/schedule/delete") && (
                                      <button
                                        className="btn btn-sm btn-outline-danger"
                                        title="Delete"
                                        onClick={() => handleDelete(item.id)}
                                      >
                                        <i className="ri-delete-bin-line"></i>
                                      </button>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="working_schedule_add"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <form action="">
              <div className="modal-header py-3 bg-label-primary">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Working Schedule Add
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="row g-4">
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className="form-control input-uppercase"
                        placeholder="Name"
                        name="name"
                      />
                      <label htmlFor="">Name</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="time"
                        className="form-control"
                        name="start_time"
                      />
                      <label htmlFor="">Start Time</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="time"
                        className="form-control"
                        name="end_time"
                      />
                      <label htmlFor="">End Time</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className="form-control"
                        name="late_mark"
                        placeholder="Late Mark (in Minutes)"
                      />
                      <label htmlFor="">Late Mark (in Minutes)</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className="form-control"
                        name="early_mark"
                        placeholder="Early Mark (in Minutes)"
                      />
                      <label htmlFor="">Early Mark (in Minutes)</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className="form-control"
                        name="overtime_mark"
                        placeholder="Overtime Mark (in Minutes)"
                      />
                      <label htmlFor="">Overtime Mark (in Minutes)</label>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <label htmlFor="" className="mb-2">
                      Working Days
                    </label>
                    <div className=" d-flex flex-wrap align-content-center gap-3">
                      {days.map((day) => (
                        <div className="form-check" key={day}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value={day}
                            id={day}
                            name="working_days[]"
                          />
                          <label className="form-check-label" htmlFor={day}>
                            {day}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer py-3 bg-label-primary">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  Save changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="working_schedule_update"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <form onSubmit={handleUpdate}>
              <div className="modal-header py-3 bg-label-primary">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Working Schedule Update
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="row g-4">
                  <input
                    type="hidden"
                    name="id"
                    id="id"
                    value={modalData?.id}
                  />
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className="form-control input-uppercase"
                        placeholder="Name"
                        name="name"
                        value={modalData?.name}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            name: e.target.value,
                          }))
                        }
                      />
                      <label htmlFor="">Name</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="time"
                        className="form-control"
                        name="start_time"
                        value={modalData?.start_time}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            start_time: e.target.value,
                          }))
                        }
                      />
                      <label htmlFor="">Start Time</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="time"
                        className="form-control"
                        name="end_time"
                        value={modalData?.end_time}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            end_time: e.target.value,
                          }))
                        }
                      />
                      <label htmlFor="">End Time</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className="form-control"
                        name="late_mark"
                        placeholder="Late Mark (in Minutes)"
                        value={modalData?.late_mark}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            late_mark: e.target.value,
                          }))
                        }
                      />
                      <label htmlFor="">Late Mark (in Minutes)</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className="form-control"
                        name="early_mark"
                        placeholder="Early Mark (in Minutes)"
                        value={modalData?.early_mark}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            early_mark: e.target.value,
                          }))
                        }
                      />
                      <label htmlFor="">Early Mark (in Minutes)</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className="form-control"
                        name="overtime_mark"
                        placeholder="Overtime Mark (in Minutes)"
                        value={modalData?.overtime_mark}
                        onChange={(e) =>
                          setModalData((prev) => ({
                            ...prev,
                            overtime_mark: e.target.value,
                          }))
                        }
                      />
                      <label htmlFor="">Overtime Mark (in Minutes)</label>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <label htmlFor="" className="mb-2">
                      Working Days
                    </label>
                    <div className="d-flex flex-wrap align-content-center gap-3">
                      {days.map((day) => (
                        <div className="form-check" key={day}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value={day}
                            id={day}
                            name="working_days[]"
                            onChange={(e) => {
                              const isChecked = e.target.checked;
                              setModalData((prev) => {
                                let updatedDays = Array.isArray(
                                  prev.working_days,
                                )
                                  ? [...prev.working_days]
                                  : JSON.parse(prev.working_days || "[]");

                                if (isChecked) {
                                  updatedDays.push(day);
                                } else {
                                  updatedDays = updatedDays.filter(
                                    (d) => d !== day,
                                  );
                                }

                                return { ...prev, working_days: updatedDays };
                              });
                            }}
                            checked={
                              Array.isArray(modalData?.working_days)
                                ? modalData.working_days.includes(day)
                                : JSON.parse(
                                  modalData?.working_days || "[]",
                                ).includes(day)
                            }
                          />
                          <label className="form-check-label" htmlFor={day}>
                            {day}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer py-3 bg-label-primary">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  Save changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
